import { Typography } from '@mui/material';

import { TargetNameAndDescription, targetNameAndDescriptionStyle } from '@/components/common/TargetNameAndDescription';
import type { MinimalTarget } from '@/generated/model';

type RefuelHeaderTitleProps = {
  selectedTarget: MinimalTarget | undefined;
  showTarget: boolean;
  fallbackTitle: string;
};

export function RefuelHeaderTitle({ selectedTarget, showTarget, fallbackTitle }: RefuelHeaderTitleProps) {
  if (selectedTarget && showTarget) {
    return (
      <TargetNameAndDescription
        targetName={selectedTarget.name}
        targetDescription={selectedTarget.description}
        styleClassName={targetNameAndDescriptionStyle(undefined, undefined)}
      />
    );
  }

  return (
    <Typography variant="h6" data-qa-element-id="refuel_tab_title">
      {fallbackTitle}
    </Typography>
  );
}
